import React from 'react';
import DatePicker from "react-multi-date-picker"
import { Button, Grid, TextField } from '@mui/material';
import "react-multi-date-picker/styles/colors/green.css"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import InputAdornment from '@mui/material/InputAdornment';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import useSubmitLock from '../../../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;


export default function AltaPrestamoEm(props) {
  const { lote } = props
  const { periodo } = props
  const { idempleado } = props
  const { notificacion } = props
  const { idconcepto } = props
  const [datearray, setDatearray] = React.useState('')
  const [dates, setDates] = React.useState()
  const { obtenerdatolote } = props
  const { datotodoempleado } = props
  const { submitting, runWithSubmitLock } = useSubmitLock()

  const fechainicio = periodo.fechainicio + 1
  const fechafin = periodo.fechafin + 1


  const [montolimite, setMontolimite] = React.useState(0);
  const [parcialidad, SetParcialidades] = React.useState(1);

  const pagostotal = montolimite / parcialidad

  const weekDays = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"]
  const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

  const handleChange2 = () => (event) => {
    setMontolimite(event.target.value);
  };


  const Addaltaprestamo = (e) => {
    e.preventDefault()
    runWithSubmitLock(async () => {
    const token = sessionStorage.getItem('%t')
    const vecesaplicar2 = parseInt(parcialidad)
    const montolimite2 = parseFloat(montolimite)

    const resul = {
      variant: 'warning',
      msg: 'Debe seleccionar por lo menos una fecha'
    }

    if (datearray === '' || idempleado === '') {
      notificacion(resul)
    } else {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");


      var raw = JSON.stringify({
        "idlote": lote,
        "idempleado": idempleado,
        "codigoempleado": datotodoempleado.codigoempleado,
        "nombrelargo": datotodoempleado.nombrelargo,
        "idconcepto": `${idconcepto}`,
        "valor": pagostotal,
        "vecesAplicar": vecesaplicar2,
        "vecesAplicado": 0,
        "montoLimite": montolimite2,
        "montoAcumulado": 0,
        "fechaInicioTarjeta": datearray,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      try {
        const response = await fetch(`${REACT_APP_API_URL}/pdim/deduccion`, requestOptions)
        const resultado = await response.json();
        return (notificacion(resultado), obtenerdatolote(lote), setDatearray(''), setDates({}), setMontolimite(''))
      } catch (error) {
        console.log('Algo salio mal', error);
      }
    }
    })
  }

  const handchange = (date) => {
    setDates(date);
    const fechastring = date.toString();
    setDatearray(fechastring);
  };

  return (
    <div>
      <br />
      <form onSubmit={Addaltaprestamo}>
        <Grid container spacing={3}>
          <Grid item sm={4} md={4} >

            <FormControl fullWidth sx={{ m: 1 }}>
              <Input
                placeholder="00.0"
                type='number'
                required
                id="standard-adornment-amount"
                value={montolimite}
                onChange={handleChange2('amount')}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
              <FormHelperText id="outlined-weight-helper-text">Monto  a prestar</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item sm={4} md={4}>
            <FormControl fullWidth sx={{ m: 1 }}>
              <TextField
                fullWidth
                required
                value={parcialidad}
                placeholder="0"
                variant="standard"
                onChange={e => SetParcialidades(e.target.value)}
                type='number'
                size="small"
              />
              <FormHelperText id="outlined-weight-helper-text">No. Parcialidades</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item sm={4} md={4} >

            <FormControl fullWidth sx={{ m: 1 }}>
              <Input
                readOnly
                placeholder="00.0"
                type='number'
                id="standard-adornment-amount"
                value={pagostotal}

                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
              <FormHelperText id="outlined-weight-helper-text">Parcialidad</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3}>

          <Grid item sm={4} md={4}>
            <br />
            <DatePicker
              weekDays={weekDays}
              months={months}
              mainPosition="top"
              fixMainPosition={true}
              calendarPosition={`top-center`}
              style={{
                backgroundColor: "aliceblue",
                height: "45px",
                borderRadius: "3px",
                fontSize: "16px",
                padding: "3px 10px"
              }}
              disableYearPicker
              className="green"
              value={dates}
              minDate={fechainicio}
              maxDate={fechafin}
              onChange={handchange}
              format="YYYY-MM-DD"
              sort
              plugins={[
                <DatePanel />
              ]}
            />
            <FormHelperText id="outlined-weight-helper-text">Fecha inicio</FormHelperText>
          </Grid>
        </Grid>

        <br />
        <Button type='submit' color="primary" variant='contained' disabled={submitting}>Agregar </Button>
      </form>
    </div>

  );
}